import * as React from 'react';
import CircularProgress from 'material-ui/CircularProgress';

interface LoaderProgressProps {
  progress: number;
}

const LoaderProgress: React.SFC<LoaderProgressProps> = ({ progress }) => (
  <div className="progress-loader">
    <CircularProgress
      mode="determinate"
      value={progress}
      size={60}
      style={{
        position: 'relative',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}
    />
  </div>
);

export default LoaderProgress;



// WEBPACK FOOTER //
// ./src/components/loader/LoaderProgress.tsx